/*
 *  -----------------------------------------------------------------------
 *    <copyright file="delete-visit/index.tsx" company="Triumph Research Intelligence">
 *        Copyright (C) 2019 by Triumph Research Intelligence. All rights reserved.
 *    </copyright>
 *   -----------------------------------------------------------------------
 *
 */

import { useMutation } from '@apollo/client/react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { DialogContent } from '@mui/material';
import React from 'react';
import { DeleteVisitDialogProps } from '@components/admin/delete-visit/delete-visit.interface';

import { useTranslation } from 'hooks';
import { DELETE_STUDY_VISIT_SCHEDULE_VISIT, GET_STUDY_VISIT_SCHEDULES } from 'queries/study-visit-schedules';
import Button from 'views/components/core/buttons';
import { CustomDialog, DialogActions, DialogTitle } from 'views/components/core/dialog';

import './styles.scss';
import {
    deleteStudyVisitScheduleVisit,
    deleteStudyVisitScheduleVisitVariables,
} from '@queries/generated/study-visit-schedules.generated';

const DeleteVisitDialog = ({ close, currentVisit, studyId, currentScheduleId }: DeleteVisitDialogProps) => {
    const { t } = useTranslation();

    const [deleteVisit] = useMutation<deleteStudyVisitScheduleVisit, deleteStudyVisitScheduleVisitVariables>(
        DELETE_STUDY_VISIT_SCHEDULE_VISIT,
    );

    const onDeleteVisit = () => {
        deleteVisit({
            variables: {
                studyId,
                visitScheduleId: currentScheduleId,
                visitId: currentVisit?.id,
            },
            refetchQueries: [
                {
                    query: GET_STUDY_VISIT_SCHEDULES,
                    variables: {
                        studyId,
                    },
                },
            ],
        }).then((reply) => (reply?.data?.deleteStudyVisitScheduleVisit ? close('delete') : close('error')));
    };

    return (
        <CustomDialog
            onClose={() => close()}
            fullWidth
            maxWidth="md"
            scroll="paper"
            open
            className="custom-width-popup"
        >
            <DialogTitle id="delete-visit-modal-title">
                {t('admin:deleteVisit')}
                <FontAwesomeIcon
                    icon={['fal', 'times']}
                    className="fa-lg close-icon-cv"
                    onClick={() => close()}
                    data-testid="close-dialog"
                />
            </DialogTitle>
            <DialogContent className="add-treatment-dialog-content">
                <div className="delete-visit-text">{t('admin:deleteVisitQuestion')}</div>
                <DialogActions className="add-treatment-dialog-content-actions flex-end">
                    <Button id="delete-visit-btn" text="delete" onClick={onDeleteVisit} />
                </DialogActions>
            </DialogContent>
        </CustomDialog>
    );
};

export default DeleteVisitDialog;
